import React, { useState } from "react";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { Button } from "../components/ui/Button";
// import Categories from "../components/Categories";
import Hero from "../components/Hero";
import {
  CategoriesSection,

} from "../components/ProductCategories";
import { sendEmail } from "../services/emailService";
import { submitLeadToFirebase } from "../services/crmLeadService";
import Swal from "sweetalert2";
import { Phone, Mail, MapPin } from "lucide-react";
import {
  FaFacebookF,
  FaWhatsapp,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { SiX } from "react-icons/si";
import products from "../data/products";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    countryCode: "+91", // default country code
    product: "", // 🆕 new field
    message: "",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);


  const socialMediaLinks = [
    {
      name: "Facebook",
      icon: FaFacebookF,
      url: "https://www.facebook.com/profile.php?id=61579068592688",
      border: "border-blue-600",
      hoverBg: "hover:bg-blue-600",
    },
    {
      name: "WhatsApp",
      icon: FaWhatsapp,
      url: "https://wa.me/message/ZXZJO52CYT3LB1",
      border: "border-green-500",
      hoverBg: "hover:bg-green-500",
    },
    {
      name: "Instagram",
      icon: FaInstagram,
      url: "https://www.instagram.com/nirmita_international/",
      border: "border-pink-600",
      hoverBg:
        "hover:bg-gradient-to-r hover:from-pink-500 hover:via-red-500 hover:to-yellow-500", // gradient effect
    },
    {
      name: "LinkedIn",
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/company/nirmita-international/",
      border: "border-blue-800",
      hoverBg: "hover:bg-blue-800",
    },
    {
      name: "X",
      icon: SiX,
      url: "https://x.com/NirmitaI2402",
      border: "border-black",
      hoverBg: "hover:bg-black",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const countries = [
    // India first (priority)
    { name: "India", code: "+91", flag: "🇮🇳" },

    // Other countries alphabetically
    { name: "Algeria", code: "+213", flag: "🇩🇿" },
    { name: "Argentina", code: "+54", flag: "🇦🇷" },
    { name: "Armenia", code: "+374", flag: "🇦🇲" },
    { name: "Australia", code: "+61", flag: "🇦🇺" },
    { name: "Austria", code: "+43", flag: "🇦🇹" },
    { name: "Azerbaijan", code: "+994", flag: "🇦🇿" },
    { name: "Bahrain", code: "+973", flag: "🇧🇭" },
    { name: "Bangladesh", code: "+880", flag: "🇧🇩" },
    { name: "Belarus", code: "+375", flag: "🇧🇾" },
    { name: "Belgium", code: "+32", flag: "🇧🇪" },
    { name: "Brazil", code: "+55", flag: "🇧🇷" },
    { name: "Bulgaria", code: "+359", flag: "🇧🇬" },
    { name: "Cambodia", code: "+855", flag: "🇰🇭" },
    { name: "Canada", code: "+1", flag: "🇨🇦" },
    { name: "Chile", code: "+56", flag: "🇨🇱" },
    { name: "China", code: "+86", flag: "🇨🇳" },
    { name: "Colombia", code: "+57", flag: "🇨🇴" },
    { name: "Croatia", code: "+385", flag: "🇭🇷" },
    { name: "Cyprus", code: "+357", flag: "🇨🇾" },
    { name: "Czech Republic", code: "+420", flag: "🇨🇿" },
    { name: "Denmark", code: "+45", flag: "🇩🇰" },
    { name: "Egypt", code: "+20", flag: "🇪🇬" },
    { name: "Estonia", code: "+372", flag: "🇪🇪" },
    { name: "Finland", code: "+358", flag: "🇫🇮" },
    { name: "France", code: "+33", flag: "🇫🇷" },
    { name: "Georgia", code: "+995", flag: "🇬🇪" },
    { name: "Germany", code: "+49", flag: "🇩🇪" },
    { name: "Greece", code: "+30", flag: "🇬🇷" },
    { name: "Hong Kong", code: "+852", flag: "🇭🇰" },
    { name: "Hungary", code: "+36", flag: "🇭🇺" },
    { name: "Iceland", code: "+354", flag: "🇮🇸" },
    { name: "Indonesia", code: "+62", flag: "🇮🇩" },
    { name: "Iraq", code: "+964", flag: "🇮🇶" },
    { name: "Ireland", code: "+353", flag: "🇮🇪" },
    { name: "Israel", code: "+972", flag: "🇮🇱" },
    { name: "Italy", code: "+39", flag: "🇮🇹" },
    { name: "Japan", code: "+81", flag: "🇯🇵" },
    { name: "Jordan", code: "+962", flag: "🇯🇴" },
    { name: "Kazakhstan", code: "+7", flag: "🇰🇿" },
    { name: "Kenya", code: "+254", flag: "🇰🇪" },
    { name: "Kuwait", code: "+965", flag: "🇰🇼" },
    { name: "Latvia", code: "+371", flag: "🇱🇻" },
    { name: "Lebanon", code: "+961", flag: "🇱🇧" },
    { name: "Libya", code: "+218", flag: "🇱🇾" },
    { name: "Lithuania", code: "+370", flag: "🇱🇹" },
    { name: "Luxembourg", code: "+352", flag: "🇱🇺" },
    { name: "Macedonia", code: "+389", flag: "🇲🇰" },
    { name: "Malaysia", code: "+60", flag: "🇲🇾" },
    { name: "Maldives", code: "+960", flag: "🇲🇻" },
    { name: "Malta", code: "+356", flag: "🇲🇹" },
    { name: "Mexico", code: "+52", flag: "🇲🇽" },
    { name: "Mongolia", code: "+976", flag: "🇲🇳" },
    { name: "Morocco", code: "+212", flag: "🇲🇦" },
    { name: "Nepal", code: "+977", flag: "🇳🇵" },
    { name: "Netherlands", code: "+31", flag: "🇳🇱" },
    { name: "New Zealand", code: "+64", flag: "🇳🇿" },
    { name: "Nigeria", code: "+234", flag: "🇳🇬" },
    { name: "Norway", code: "+47", flag: "🇳🇴" },
    { name: "Oman", code: "+968", flag: "🇴🇲" },
    { name: "Pakistan", code: "+92", flag: "🇵🇰" },
    { name: "Panama", code: "+507", flag: "🇵🇦" },
    { name: "Paraguay", code: "+595", flag: "🇵🇾" },
    { name: "Peru", code: "+51", flag: "🇵🇪" },
    { name: "Philippines", code: "+63", flag: "🇵🇭" },
    { name: "Poland", code: "+48", flag: "🇵🇱" },
    { name: "Portugal", code: "+351", flag: "🇵🇹" },
    { name: "Qatar", code: "+974", flag: "🇶🇦" },
    { name: "Romania", code: "+40", flag: "🇷🇴" },
    { name: "Russia", code: "+7", flag: "🇷🇺" },
    { name: "Saudi Arabia", code: "+966", flag: "🇸🇦" },
    { name: "Senegal", code: "+221", flag: "🇸🇳" },
    { name: "Serbia", code: "+381", flag: "🇷🇸" },
    { name: "Seychelles", code: "+248", flag: "🇸🇨" },
    { name: "Singapore", code: "+65", flag: "🇸🇬" },
    { name: "Slovakia", code: "+421", flag: "🇸🇰" },
    { name: "Slovenia", code: "+386", flag: "🇸🇮" },
    { name: "South Africa", code: "+27", flag: "🇿🇦" },
    { name: "South Korea", code: "+82", flag: "🇰🇷" },
    { name: "Spain", code: "+34", flag: "🇪🇸" },
    { name: "Sri Lanka", code: "+94", flag: "🇱🇰" },
    { name: "Sweden", code: "+46", flag: "🇸🇪" },
    { name: "Switzerland", code: "+41", flag: "🇨🇭" },
    { name: "Taiwan", code: "+886", flag: "🇹🇼" },
    { name: "Thailand", code: "+66", flag: "🇹🇭" },
    { name: "Tunisia", code: "+216", flag: "🇹🇳" },
    { name: "Turkey", code: "+90", flag: "🇹🇷" },
    { name: "UAE", code: "+971", flag: "🇦🇪" },
    { name: "Ukraine", code: "+380", flag: "🇺🇦" },
    { name: "United Kingdom", code: "+44", flag: "🇬🇧" },
    { name: "United States", code: "+1", flag: "🇺🇸" },
    { name: "Uruguay", code: "+598", flag: "🇺🇾" },
    { name: "Uzbekistan", code: "+998", flag: "🇺🇿" },
    { name: "Venezuela", code: "+58", flag: "🇻🇪" },
    { name: "Vietnam", code: "+84", flag: "🇻🇳" },
    { name: "Zimbabwe", code: "+263", flag: "🇿🇼" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate message word count (min 5 words)
    const wordCount = formData.message.trim().split(/\s+/).length;
    if (wordCount < 5) {
      Swal.fire({
        icon: "error",
        title: "Message too short",
        text: "Please enter at least 5 words in your message.",
        confirmButtonColor: "#73340E",
      });
      return;
    }
    try {
      // Your Firebase user ID (replace with actual user ID)
      const userId = "WVbWMAuaxQXbFIjWIDWalTlqgSj1";

      // Submit to Firebase Cloud Function for CRM lead creation
      const firebaseResult = await submitLeadToFirebase(formData, userId);
      console.log("Lead submitted to Firebase:", firebaseResult);

      // Send email notification
      const emailData = {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        subject: "Contact Form Submission",
        message: formData.message,
        mobile: `${formData.countryCode} ${formData.mobile}`,
        product: formData.product,
      };

      await sendEmail(emailData);
      setFormSubmitted(true);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Your message has been successfully submitted.",
        confirmButtonColor: "#73340E",
      });

      setTimeout(() => {
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          countryCode: "+91",
          product: "", // reset product
          message: "",
        });
        setFormSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error("Form submission error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: error.message || "Something went wrong. Please try again later.",
        confirmButtonColor: "#73340E",
      });
    }
  };

  return (
    <main className="min-h-screen bg-[#FBF1EB]">
      <Hero isHome={false} />

      {/* Heading */}
      <div className="w-full py-8 px-4 md:px-8 bg-[#FBF1EB]">
        <h1 className="text-3xl md:text-4xl font-bold text-[#4b2e19] text-center mb-10 drop-shadow-sm">
          Contact Us
        </h1>
      </div>

      {/* Contact Section */}
      <section className="w-full py-8 px-4 md:px-8 bg-[#FBF1EB]">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Side - Contact Information */}
            <div className="space-y-8">
              {/* Contact Info Cards */}
              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-sm border border-[#E8D9C8]">
                  <div className="bg-[#000000] p-3 rounded-full">
                    <Mail className="text-white w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-700 mb-1">
                      Send us an email
                    </h3>
                    <a
                      href="mailto:info@nirmitainternational.com"
                      className="text-[#2c541d] hover:underline text-lg"
                    >
                      info@nirmitainternational.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-sm border border-[#E8D9C8]">
                  <div className="bg-[#000000] p-3 rounded-full">
                    <Phone className="text-white w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-700 mb-1">
                      Give us a call
                    </h3>
                    <a
                      href="tel:+919112474911"
                      className="text-[#2c541d] hover:underline text-lg"
                    >
                      +91 9112474911
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-sm border border-[#E8D9C8]">
                  <div className="bg-[#000000] p-3 rounded-full">
                    <MapPin className="text-white w-5 h-5" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-700 mb-1">
                      Our Location
                    </h3>
                    <p className="text-gray-600 text-lg">
                     Pune, Maharashtra, India
                    </p>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="bg-white rounded-lg shadow-sm border border-[#E8D9C8] p-6">
                <div className="w-full h-64 rounded-lg overflow-hidden">
                 <iframe
                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d242118.06894793978!2d73.72287839999999!3d18.524616450000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f11!3m3!1m2!1s0x3bc2bf2e67461101%3A0x828d43bf9d9ee343!2sPune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1760093165415!5m2!1sen!2sin"
                   className="w-full h-full"
                   style={{border: 0}}
                   allowFullScreen=""
                   loading="lazy"
                   referrerPolicy="no-referrer-when-downgrade"
                   title="Pune, Maharashtra Location Map"
                 ></iframe>
                </div>
              </div>
            </div>
            {/* Right Side - Contact Form */}
            <div className="bg-white rounded-lg shadow-sm border border-[#E8D9C8] p-6 md:p-8">
              <h2 className="text-2xl font-bold text-[#2c541d] mb-6">
                Get In Touch
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Name Row - Two Columns */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                  <div>
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      First Name *
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="Enter your first name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent transition-colors duration-200"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="lastName"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Last Name *
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Enter your last name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent transition-colors duration-200"
                    />
                  </div>
                </div>

                {/* Email - Full Width */}
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent transition-colors duration-200"
                  />
                </div>

                {/* Mobile Number with Country Code - Full Width */}
                <div>
                  <label
                    htmlFor="mobile"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Mobile Number *
                  </label>
                  <div className="relative flex items-center gap-0">
                    {/* Country Code Selector - Compact */}
                    <div className="relative">
                      <select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            countryCode: e.target.value,
                          }))
                        }
                        className="h-full px-3 py-3 pr-8 border border-r-0 border-gray-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent bg-gray-50 transition-colors duration-200 cursor-pointer appearance-none text-sm font-medium"
                        style={{ minWidth: '85px' }}
                      >
                        {countries.map((c, index) => (
                          <option key={`${c.code}-${index}`} value={c.code}>
                            {c.flag} {c.code}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                        </svg>
                      </div>
                    </div>

                    {/* Mobile Input */}
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="Enter mobile number"
                      required
                      pattern="[0-9]{10}"
                      className="flex-1 px-4 py-3 border border-gray-300 rounded-r-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent transition-colors duration-200"
                    />
                  </div>
                  <p className="mt-1 text-xs text-gray-500">
                    Enter 10-digit mobile number
                  </p>
                </div>

                {/* Product Selection */}
<div>
  <label
    htmlFor="product"
    className="block text-sm font-medium text-gray-700 mb-2"
  >
    Select Product *
  </label>
  <select
    id="product"
    name="product"
    value={formData.product}
    onChange={handleChange}
    required
    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent bg-gray-50 transition-colors duration-200"
  >
    <option value="">-- Choose a product --</option>
    {products.map((p) => (
      <option key={p.id} value={p.name}>
        {p.name}
      </option>
    ))}
  </select>
</div>


                {/* Message */}
                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help you..."
                    required
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2c541d] focus:border-transparent resize-none transition-colors duration-200"
                  />
                </div>

                {/* Submit Button */}
                <div className="flex justify-center pt-4">
                  <button
                    type="submit"
                    disabled={formSubmitted}
                    className={`${
                      formSubmitted
                        ? "bg-green-600 cursor-not-allowed"
                        : "bg-[#000000] hover:bg-[#3d6b2a] transform hover:scale-105"
                    } text-white px-8 md:px-12 py-3 md:py-4 rounded-lg font-semibold text-lg transition-all duration-300 min-w-[140px] shadow-md hover:shadow-lg`}
                  >
                    {formSubmitted ? (
                      <div className="flex items-center justify-center gap-2">
                        <svg
                          className="w-5 h-5 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Message Sent!
                      </div>
                    ) : (
                      "Submit Message"
                    )}
                  </button>
                </div>

                {formSubmitted && (
                  <div className="text-center p-4 bg-green-50 border border-green-200 rounded-lg">
                    <p className="text-green-600 font-medium flex items-center justify-center gap-2">
                      <svg
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Thank you for your message! We'll get back to you soon.
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <CategoriesSection isHome={true} />

      {/* Social Media Icons Section */}
      <div className="bg-white rounded-xl shadow-md border border-[#E8D9C8] p-4 w-full">
        <div className="grid grid-cols-5 gap-2 justify-items-center">
          {socialMediaLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group w-full h-16 flex items-center justify-center border ${social.border} rounded-md transition-all duration-300 ${social.hoverBg}`}
            >
              <social.icon className="w-6 h-6 text-gray-700 transition-all duration-300 group-hover:text-white" />
            </a>
          ))}
        </div>
      </div>
    </main>
  );
};

export default ContactUs;
